import React, { FC } from 'react'
import { graphql, useStaticQuery } from 'gatsby'

import { HubspotFormFragmentFragment } from '@graphqlTypes'

import HubspotForm from '@components/HubspotForm/HubspotForm'
import Modal from '@components/Modal/Modal'

import {
  ClassesPageRegisterModalDIV,
  ClassesPageRegisterModalContentDIV,
} from './ClassesPageRegisterModal.styles'

type ClassesPageRegisterModalProps = {
  classTime: {
    dt: any,
    timestamp: string,
    webinarKey: string,
  },
  classTitle: string,
  onClose: () => void,
}

const ClassesPageRegisterModal: FC<ClassesPageRegisterModalProps> = ({
  classTime,
  classTitle,
  onClose,
}) => {
  const { hubspotForm } = useStaticQuery<{ hubspotForm: HubspotFormFragmentFragment }>(graphql`
    query ClassesPageRegisterModalQuery {
      hubspotForm(alternative_id: {eq: "0716588a-fa62-4125-873a-eb238e1ea270"}) {
        ...HubspotFormFragment
      }
    }
  `)

  const handleSubmit = (formEl: HTMLFormElement) => {
    const regTimeStampEl: HTMLInputElement | null = formEl.querySelector('input[name="go_to_webinar_registration_time_stamp"]')
    if (regTimeStampEl) regTimeStampEl.value = classTime.timestamp

    const registrationDayEl: HTMLInputElement | null = formEl.querySelector('input[name="go_to_webinar_registration_day"]')
    if (registrationDayEl) registrationDayEl.value = classTime.dt.toFormat('cccc')

    const zoomWebinarKeyEl: HTMLInputElement | null = formEl.querySelector('input[name="zoom_webinar_key"]')
    if (zoomWebinarKeyEl) zoomWebinarKeyEl.value = classTime.webinarKey

    const registrationDateEl: HTMLInputElement | null = formEl.querySelector('input[name="go_to_webinar_registration_date"]')
    if (registrationDateEl) registrationDateEl.value = classTime.dt.toFormat('LLLLD')

    const eventDateEl: HTMLInputElement | null = formEl.querySelector('input[name="zoom_webinar_event_date"]')
    if (eventDateEl) eventDateEl.value = classTime.dt.toFormat('y-LL-dd')

    const registrationTimeEl: HTMLInputElement | null = formEl.querySelector('input[name="go_to_webinar_registration_time"]')
    if (registrationTimeEl) registrationTimeEl.value = `${classTime.dt.toFormat('ha')} ${classTime.dt.offsetNameShort}`
  }

  return (
    <Modal
      hideCloseButton
      onClose={onClose}
      useInsetCloseButton
    >
      <ClassesPageRegisterModalDIV>
        <ClassesPageRegisterModalContentDIV>
          <p className="font--text-S"><span>You’re registering for</span> <strong>{classTitle}</strong></p>
          <h4>{classTime.dt.toFormat('DDDD')}<br />{classTime.dt.toFormat('ha')} {classTime.dt.offsetNameShort}</h4>
        </ClassesPageRegisterModalContentDIV>
        <HubspotForm
          {...hubspotForm}
          isCompact
          onSubmit={handleSubmit}
        />
      </ClassesPageRegisterModalDIV>
    </Modal>
  )
}

export default ClassesPageRegisterModal
